import { getRelatedContent } from 'SharedHelpers/getRelatedContent';
import { getConvertrForm } from 'SharedPartials/getConvertrForm';
import { getNextPagesForArticleAndReview } from 'SharedPartials/getNextPagesForArticleAndReview';
import { getSocialAndTagsWrapper } from 'SharedPartials/getSocialAndTagsWrapper';
import { getSocial } from 'SharedPartials/getSocial';
import { getTags } from 'SharedPartials/getTags';

export const getArticleBottomComponents = ({ props, extraBottomComponents = [] }) => {
  const {
    amp,
    config: {
      siteUrl,
      globalSettings: {
        converterPublisherId,
      },
    },
    layoutData: {
      page: {
        associatedContent,
        tags,
        title,
        url,
        resources,
      },
    },
  } = props;
  const bottomComponents = [].concat(extraBottomComponents);

  if (!amp && converterPublisherId) {
    const publisherId = converterPublisherId || '3';
    const whitepaperResource = (resources && resources.whitepaper) ? resources.whitepaper : null;
    const whitepaperObject = { formId: '1', publisherId, ...whitepaperResource };
    bottomComponents.push(getConvertrForm(whitepaperObject));
  }

  const multipage = getRelatedContent({ related: associatedContent, key: 'relatedPages' });
  if (multipage && multipage.length) {
    bottomComponents.push(getNextPagesForArticleAndReview(multipage, url, 'Continue Reading'));
  }

  const socialAndTags = getSocialAndTagsWrapper(getTags(tags), getSocial(siteUrl, url, title, { 'polaris__article--social': true }));
  bottomComponents.push(socialAndTags);

  return bottomComponents;
};
